import styles from './deals.module.css'
import ProductDetail from "../../sharedComponents/productDetail/productDetail";
import {useEffect, useState} from "react";

const Deals = (props) =>
{
	let number = props.number
	let name = props.name
	let summary = props.description ? props.description : ''
	let image = props.imageUrl
	const [getModel, setModel] = useState();

	const reverse = props.number % 2 === 0

	function maxString(str, length = 100)
	{
		return str.length > length ? str.substring(0, length) + '...' : str;
	}

	// function onLearnMore()
	// {
	// 	setModel(true)
	// 	console.log('deals open', getModel)
	// }
	//
	// function closeLearnMore() {
	// 	setModel(false)
	// 	console.log('deals close', getModel)
	// }




	return (
		<>
			<div className={styles.outerContainer} onClick={() => setModel(true)}>
				<div className={reverse ? styles.innerContainer + ' ' + styles.reverse : styles.innerContainer}>
					<div className={styles.info}>
						<div className={styles.number}>{number}</div>
						<h1>{name}</h1>
						<p>{maxString(summary, 250)}</p>
					</div>
					<div className={styles.blank}></div>
				</div>
				<div className={reverse ? styles.placeHolder + ' ' + styles.reverse : styles.placeHolder}>
					<div className={styles.blankText}></div>
					<div className={styles.image}>
						<img src={image} alt=""/>
					</div>
				</div>
				{/*{getModel ? <ProductDetail {...props} onClose={() => setModel(false)}/> : null}*/}
				{/*{getModel ? <ProductDetail {...props} show={getModel} onClose={closeLearnMore}/> : null}*/}
			</div>
		</>
	)
}

export default Deals